import React from 'react';
import Typography from '@material-ui/core/Typography';

import './index.scss';

export default function GroupTitle(props) {
    const { element, isShort = false , noStyles} = props

    let generalClass = 'title';
    if(props.smallTitle) generalClass = 'cellTitle';

    let title = element.ProductName
    if(element.GroupName && element.GroupName !== null) title = element.GroupName
    
    if(isShort){
        title = element.ProductName
        if(element.ShortName) title = element.ShortName
    }

    if(noStyles) return title;

    return(
        <div className="groupTitle">
            <Typography variant="h6" component="h3" className={generalClass}>
                {title}
            </Typography>
        </div>
    )
}
